<app-poke-header></app-poke-header>

<main *ngIf="pokemon" class="fadeIn">
  <section class="pokemon-names slideInDown">
    <h1>{{ pokemon[0]?.name }}</h1>
    <h2>{{ pokemon[1]?.names[0]?.name }}</h2>
  </section>

  <section class="pokemon-status">
    <article class="pokemon-status-statistics">
      <section>
        <h3 class="slideInDown">Estatísticas</h3>
        <ol>
          <li *ngFor="let value of pokemon[0].stats" class="slideInDown">
            {{ value.stat.name }}
            <strong>
              {{ value.base_stat }}
            </strong>
          </li>
        </ol>
      </section>
    </article>
    <div class="image">
      <img [src]="pokemon[0].sprites.other.dream_world.front_default"
        [alt]="pokemon[0].name"
        class="fadeIn"
      >
    </div>
  </section>
  <a [routerLink]="['']" class="btn slideInUp">
    Voltar
  </a>
</main>
